import React from 'react';
import NameSection from './name-section/section';

export default function ProfileTab() {
  return <NameSection />;
}
